import React from 'react'
import {
  Label,
  Popup
} from 'semantic-ui-react'
import { countItems } from './utils.js'

// One counter for each choice of each enum
const ItemCounter = ({fqidPrefix, itemKind, items, type}) => {
  //console.log("ItemCounter::render()", fqidPrefix, itemKind, items, type);
  const counts = countItems(fqidPrefix, itemKind, items, type);
  return (
    type.map((e,ei)=>
      <span key={ei} style={{marginRight: '8px'}}>
        {
          e.choices.map((c,ci)=>
            <Popup
              key={ci}
              trigger={
                <Label circular color={counts[e.id][c.id]>0?c.color:null}>{counts[e.id][c.id]}</Label>
              }
              content={
                <div>
                  <strong>{e.name}:</strong> {c.name}
                  <p style={{fontSize: '80%'}}>
                    <span style={{color: 'grey'}}>{c.description}</span>
                  </p>
                  <p>
                    {
                      counts[e.id][c.id]+' '+
                      (itemKind==='outcomes'?'Outcomes':(itemKind==='topics'?'Topics':'Items'))+
                      ' within '+fqidPrefix
                    }
                  </p>
                </div>
              }
            />
          )
        }
      </span>
    )
  );
}

export default ItemCounter;